// extracted by mini-css-extract-plugin
export default {"footerBg":"Ia-z","footerTopLinks":"Ja-z","footerFeedback":"Ka-z","footerSocial":"La-z","footerLegalLinks":"Ma-z","footerIconCards":"Na-z","footerBotCopy":"Oa-z"};